import { TableRow as BaseTableRow } from 'components/infinite_data_source_table/styled';
import { BaseWidgetContainer } from 'components/page/BaseLandingPage';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Container = styled(BaseWidgetContainer)`
    gap: 1.2rem;
`;

export const TableRow = styled(BaseTableRow)<{
    $isSystem?: boolean;
    $isExpanded?: boolean;
    $nestingLevel?: number;
}>`
    ${({ $isSystem }) =>
        $isSystem &&
        `
        td:first-child {
            padding-left: 3.2rem;
        }
    `};
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;

export const Title = styled.h2`
    font-size: 2.4rem;
    line-height: 1.25;
    font-weight: 500;
    margin: 0;
    color: ${tokens.text.primary};
`;

export const SystemRow = styled(TableRow)`
    padding-left: 2.4rem;
`;
